import React from 'react'
import ReactSVG from 'react-svg'
import PropTypes from 'prop-types'
import { propType } from 'graphql-anywhere'
import classNames from 'classnames'
import styles from './rate-option.css'
import USER_RATING_FRAGMENT from '../../../graphql/fragments/user-rating.gql'
import { getIconAndLabelForRateOption, UserRatingScale } from './shared'

/**
 * represent each rate option, that can be used by either show page or player
 * * defaultScale: one of three rating values this option stands for (e.g. {@link UserRatingScale.NOT_MY_THING})
 * * userRating: user's current rating, refer to schema type `UserRating`
 * * onRateClick: func from parent
 * * inPlayer: whether the option is used on show page or in the player
 * * inPlayerRateModal: whether the option is used on PlayerBannerRateModal
 */
const RateOption = React.forwardRef(({
  defaultScale,
  userRating,
  onRateClick,
  inPlayer,
  inPlayerRateModal
}, ref) => {
  // 2 rate modals (show page - DetailRateButtonAndModal, and player end - PlayerBannerRateModal) need label
  const shouldDisplayLabel = inPlayerRateModal || !inPlayer
  const { ratingIcon, ratingLabel } = getIconAndLabelForRateOption(
    defaultScale,
    userRating
  )
  return (
    <div
      ref={ref}
      className={classNames(styles.rateOption, {
        [styles.inPlayer]: inPlayer
      })}
      onClick={() => onRateClick(defaultScale, ref)}
    >
      <div
        className={classNames(styles.rateIconWrapper, {
          [styles.inPlayerRateModal]: inPlayerRateModal
        })}
      >
        <ReactSVG
          src={ratingIcon}
          beforeInjection={svg => {
            svg.setAttribute(
              'class',
              classNames(styles.rateIcon, {
                [styles.inPlayer]: inPlayer
              })
            )
          }}
        />
      </div>
      {shouldDisplayLabel && (
        <div className={styles.rateLabel}>{ratingLabel}</div>
      )}
    </div>
  )
})
RateOption.propTypes = {
  defaultScale: PropTypes.oneOf(Object.values(UserRatingScale)).isRequired,
  userRating: propType(USER_RATING_FRAGMENT),
  onRateClick: PropTypes.func.isRequired,
  inPlayer: PropTypes.bool,
  inPlayerRateModal: PropTypes.bool
}
RateOption.defaultProps = {
  inPlayer: false,
  inPlayerRateModal: false
}
export default RateOption
